// web/src/features/account/sportsPaySignUp/hooks/useNotifySportsPayComplete.ts
import { useMutation } from '@tanstack/react-query'
import { notifySportsPayComplete } from '@sportninja/common/services/account'
import type { NotifySportsPayCompleteArgs } from '@sportninja/common/services/account'

/**
 * Records a completed SportsPay registration against the account.
 *
 * `retry: 0` — this fires once, off the completion callback, and the UI already
 * degrades safely when it fails (the frame still closes and the org still
 * refetches), so a silent retry would only delay that.
 */
export const useNotifySportsPayComplete = () =>
  useMutation<unknown, Error, NotifySportsPayCompleteArgs>({
    mutationFn: (args) => notifySportsPayComplete(args),
    retry: 0,
  })
